export const minPasswordLength = 8;

export const isValidEmail = (email: string) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

export const validatePassword = (password: string, setPasswordInvalid: any) => {
  if (password.length < minPasswordLength) {
    setPasswordInvalid(true);
  }
  if (!/[A-Z]/.test(password)) {
    setPasswordInvalid(true);
  }
  if (!/[£$%&#?!,.]/.test(password)) {
    setPasswordInvalid(true);
  }
};

export const isUserOlderThan15 = (DOB: any): boolean => {
  var today = new Date();
  var birthDate = new Date(DOB);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age > 15;
};
